/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'raigmore/clock': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10 0C4.485 0 0 4.485 0 10s4.485 10 10 10 10-4.485 10-10S15.515 0 10 0zm0 1.304A8.686 8.686 0 0118.696 10 8.686 8.686 0 0110 18.696 8.686 8.686 0 011.304 10 8.686 8.686 0 0110 1.304zm0 1.522a.652.652 0 00-.652.652V10c0 .36.292.652.652.652h6.087a.652.652 0 000-1.304h-5.435v-5.87A.652.652 0 0010 2.826z" _fill="#1B365D"/>'
  }
})
